import '../styles/media.scss';

const CAPTION_SELECTOR = '[data-media-caption]';
const TEXT_SELECTOR = '[data-media-caption-text]';
const EXPANDED_CLASS = 'is-expanded';
const TOGGLEABLE_CLASS = 'is-toggleable';
const TOGGLE_KEYS = [' ', 'Enter'];

const refreshCaption = (caption) => {
    const text = caption.querySelector(TEXT_SELECTOR);

    if (!text) {
        return;
    }

    const wasExpanded = caption.classList.contains(EXPANDED_CLASS);

    caption.classList.remove(EXPANDED_CLASS);
    caption.classList.add(TOGGLEABLE_CLASS);
    const isOverflowing = text.scrollHeight > text.clientHeight + 1;

    caption.classList.toggle(TOGGLEABLE_CLASS, isOverflowing);
    caption.classList.toggle(EXPANDED_CLASS, isOverflowing && wasExpanded);

    if (!isOverflowing) {
        caption.removeAttribute('role');
        caption.removeAttribute('tabindex');
        caption.removeAttribute('aria-expanded');
        return;
    }

    caption.setAttribute('role', 'button');
    caption.setAttribute('tabindex', '0');
    caption.setAttribute('aria-expanded', String(wasExpanded));
};

const toggleCaption = (caption) => {
    if (!caption.classList.contains(TOGGLEABLE_CLASS)) {
        return;
    }

    caption.classList.toggle(EXPANDED_CLASS);
    refreshCaption(caption);
};

const initCaption = (caption) => {
    caption.addEventListener('click', () => toggleCaption(caption));

    caption.addEventListener('keydown', (event) => {
        if (!TOGGLE_KEYS.includes(event.key)) {
            return;
        }

        event.preventDefault();
        toggleCaption(caption);
    });

    refreshCaption(caption);
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(CAPTION_SELECTOR).forEach(initCaption);
});

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        document.querySelectorAll(CAPTION_SELECTOR).forEach(refreshCaption);
    }, 150);
});
